import { render, staticRenderFns } from "./newsPage05.vue?vue&type=template&id=6ccae3f2&scoped=true&"
import script from "./newsPage05.vue?vue&type=script&lang=js&"
export * from "./newsPage05.vue?vue&type=script&lang=js&"
import style0 from "./newsPage05.vue?vue&type=style&index=0&id=6ccae3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccae3f2",
  null
  
)

export default component.exports